import { initializeApp } from "firebase/app";
import { firebaseConfig } from "./config";

export const firebaseApp = initializeApp(firebaseConfig);
